import { Typography } from "@material-ui/core"
import React from "react"

const AccountDeletion = () => {
	return (
		<div style={{marginTop: 20}}>
		<Typography>En PAGO 46, la eliminación de datos sensibles se realiza de la siguiente manera:</Typography>
		<ul>
			<li><Typography>Nombre del Usuario: Eliminación de nombres completos.</Typography></li>
			<li><Typography>Dirección de Correo Electrónico: Borrado de las direcciones de email asociadas.</Typography></li>
			<li><Typography>ID de Usuario: Supresión de identificadores de cuentas de usuario.</Typography></li>
			<li><Typography>Dirección Física: Eliminación de direcciones residenciales o comerciales.</Typography></li>
			<li><Typography>Número de Teléfono: Borrado de números telefónicos vinculados a usuarios.</Typography></li>
		</ul>
		<Typography>Este proceso asegura la protección de la privacidad del usuario y la seguridad de los datos.</Typography>
		</div>
	)
}

export default AccountDeletion;